import { lazy } from "react";

export type { IEditGifPopupProps } from "./types";

export const EditGifPopup = lazy(() => import("./EditGifPopup"));
